import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import "./custom.css";
import { StorageServices } from "./core/services";
import { ContentApp, ContentLayout, Login } from "./core/modules/roots";

export default class App extends React.Component<any, any> {
  static displayName = App.name;

  constructor(props: any) {
    super(props);

    this.state = {
      isAuthenticated: StorageServices.ExistsCookieUser(),
    };
  }

  onUserLogin() {
    this.setState({ isAuthenticated: true });
  }

  render() {
    const { isAuthenticated } = this.state;

    return (
      <Routes>
        <Route path="/" element={<ContentLayout />}>
          <Route
            index
            element={
              isAuthenticated ? (
                <Navigate to="/readysize" />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to="/readysize" />
              ) : (
                <Login onSuccess={() => this.onUserLogin()} />
              )
            }
          />
          <Route
            path="/readysize/*"
            element={
              !isAuthenticated ? <Navigate to="/login" /> : <ContentApp />
            }
          />
          <Route path="/fitLogin" element={<h1>FitLogin TiendaNube</h1>} />
        </Route>
      </Routes>
    );
  }
}
